import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import app from "./Setup"
import { v4 } from "uuid"
const storage = getStorage(app);

const uploadFile = (name, file) => {
    return new Promise((resolve, reject) => {
        const mountainsRef = ref(storage, `images/${name + v4()}`);
        uploadBytes(mountainsRef, file)
            .then((snapshot) => {
                resolve('Uploaded a blob or file!', snapshot);
            })
            .catch((err) => {
                reject('Uploaded a blob or file!', err);
            })
    })
}

const getFile = (name) => {
    return new Promise((resolve, reject) => {
        // getDownloadURL(ref(storage, `images/${"Hafeez Hussain (Mern).pdfff2a5989-f19f-4208-b6d4-2c2e5328ade8"}`))
        getDownloadURL(ref(storage, `images/Full stack Developer.pdf37a410fa-9c31-4192-8e87-f1d1fd520731`))
            .then((succ) => {
                resolve(succ)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export { uploadFile, getFile }